<template>
  <Wrapper pageIcon="security">
    <form v-on:submit.prevent="saveEmail" autocomplete="off">
      <FieldWrapper>
        <input
          slot="input"
          type="email"
          :value="user.email"
          @input="update"
          name="email"
          placeholder="E-mail"
          v-validate="validatorDefinitions.email_new"
          data-vv-scope="email"
        />
        <div slot="errors" v-if="errors.has('email', 'email')">
          {{ errors.first("email", "email") }}
        </div>
      </FieldWrapper>
      <FieldWrapper>
        <input
          slot="input"
          type="email"
          v-model="temp.email_confirmation"
          name="email_confirmation"
          placeholder="E-mail Confirmation"
          v-validate="validatorDefinitions.email_confirmation"
          data-vv-scope="email"
        />
        <div slot="errors" v-if="errors.has('email_confirmation', 'email')">
          {{ errors.first("email_confirmation", "email") }}
        </div>
      </FieldWrapper>
      <DecoratedButton
        slot="button"
        name="save"
        :loading="loaders.email"
        type="submit"
      >
        UPDATE E-MAIL ADDRESS
      </DecoratedButton>
    </form>
    <Divider size="2em" />
    <form v-on:submit.prevent="savePassword" autocomplete="off">
      <FieldWrapper v-if="user.hasPassword">
        <input
          type="password"
          v-model="temp.password_old"
          name="password_old"
          placeholder="Current Password"
          autocomplete="off"
          v-validate=""
          data-vv-scope="password"
        />
        <div slot="errors" v-if="errors.has('password_old', 'password')">
          {{ errors.first("password_old", "password") }}
        </div>
      </FieldWrapper>
      <FieldWrapper>
        <PasswordStrength slot="input" :password="temp.password">
          <input
            type="password"
            v-model="temp.password"
            name="password"
            placeholder="New Password"
            autocomplete="off"
            v-validate="validatorDefinitions.password_new"
            data-vv-scope="password"
          />
        </PasswordStrength>
        <div slot="errors" v-if="errors.has('password', 'password')">
          {{ errors.first("password", "password") }}
        </div>
      </FieldWrapper>
      <FieldWrapper>
        <input
          slot="input"
          type="password"
          v-model="temp.password_confirmation"
          v-validate="validatorDefinitions.password_confirmation"
          name="password_confirmation"
          data-vv-scope="password"
          autocomplete="off"
          placeholder="New Password Confirmation"
        />
        <div
          slot="errors"
          v-if="errors.has('password_confirmation', 'password')"
        >
          {{ errors.first("password_confirmation", "password") }}
        </div>
      </FieldWrapper>
      <DecoratedButton slot="button" :loading="loaders.password" type="submit">
        SET NEW PASSWORD
      </DecoratedButton>
    </form>
    <Divider size="3em" />
    <SectionHeader>
      <h1>Two-Factor Authentication</h1>
    </SectionHeader>
    <div>
      <TwoFactor @close="reload" />
    </div>
    <Divider size="3em" />
    <SectionHeader>
      <h1>Connected Accounts</h1>
    </SectionHeader>
    <grid wrap="wrap">
      <grid-item size="1/3" :rwd="{ compact: '1/2' }">
        <DecoratedButton
          loaderColor="#4c4c4c"
          :loading="loading === 'steam'"
          :disabled="user.steam_id"
          @click="thirdPartyProviderToggle('steam', user.steam_id)"
          backgroundColor="transparent"
          borderColor="transparent"
          color="#000"
          v-tooltip="{ content: user.steam_id ? '' : 'Connect' }"
        >
          <IconSteam :rounded="true" />
        </DecoratedButton>
        <div v-if="user.steam_id">
          <a
            :href="'http://steamcommunity.com/profiles/' + user.steam_id"
            target="_blank"
          >
            <Icon type="external-link" />
          </a>
        </div>
      </grid-item>
      <grid-item size="1/3" :rwd="{ compact: '1/2' }">
        <DecoratedButton
          loaderColor="#3a5ba2"
          :loading="loading === 'facebook'"
          :disabled="user.facebook_id"
          @click="thirdPartyProviderToggle('facebook', user.facebook_id)"
          backgroundColor="transparent"
          borderColor="transparent"
          color="#000"
          v-tooltip="{ content: user.facebook_id ? '' : 'Connect' }"
        >
          <IconFacebookBlue :rounded="true" />
        </DecoratedButton>
        <div v-if="user.facebook_id">
          <a :href="'https://facebook.com/' + user.facebook_id" target="_blank">
            <Icon type="external-link" />
          </a>
        </div>
      </grid-item>
      <!--
      <grid-item size="1/4" :rwd="{ compact: '1/2' }">
        <DecoratedButton
          :loading="loading === 'twitter'"
          loaderColor="#1ebef0"
          :disabled="user.twitter_id"
          @click="thirdPartyProviderToggle('twitter', user.twitter_id)"
          backgroundColor="transparent"
          borderColor="transparent"
          color="#000"
          v-tooltip="{ content: user.twitter_id ? '' : 'Connect' }"
        >
          <IconTwitterBlue :rounded="true" />
        </DecoratedButton>
        <div v-if="user.twitter_id">
          <a
            :href="'https://twitter.com/intent/user?user_id=' + user.twitter_id"
            target="_blank"
          >
            <Icon type="external-link" />
          </a>
        </div>
      </grid-item>
      -->
      <grid-item size="1/3" :rwd="{ compact: '1/2' }">
        <DecoratedButton
          :loading="loading === 'google'"
          loaderColor="#dc4e41"
          :disabled="user.google_id"
          @click="thirdPartyProviderToggle('google', user.google_id)"
          backgroundColor="transparent"
          borderColor="transparent"
          color="#000"
          v-tooltip="{ content: user.google_id ? '' : 'Connect' }"
        >
          <IconGoogle :rounded="true" />
        </DecoratedButton>
        <div v-if="user.google_id">
          <a
            :href="'https://plus.google.com/u/0/' + user.google_id"
            target="_blank"
          >
            <Icon type="external-link" />
          </a>
        </div>
      </grid-item>
    </grid>
  </Wrapper>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import Wrapper from "@/components/partials/profile/Wrapper";
import Loader from "vue-spinner/src/BounceLoader";
import SocialIcons from "@/components/partials/icons";
import TwoFactor from "./../modals/profile/twoFactor/Index";

import PasswordStrength from "@/components/partials/PasswordStrength";

export default {
  name: "form-profile-login",
  components: { Loader, Wrapper, TwoFactor, PasswordStrength, ...SocialIcons },
  data: function() {
    return {
      temp: {
        password_old: "",
        password_confirmation: "",
        password: "",
        email_confirmation: ""
      },
      loading: false,
      showTwoFactor: false
    };
  },
  computed: {
    ...mapGetters("user", {
      user: "getUser",
      loaders: "getLoaders"
    }),
    isFormDirty() {
      return (
        Object.keys(this.fields.$email).some(
          key => this.fields.$email[key].dirty
        ) ||
        Object.keys(this.fields.$password).some(
          key => this.fields.$password[key].dirty
        )
      );
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.isFormDirty) {
      if (
        confirm(
          "You have some unsaved changes, are you sure you want to continue?"
        ) == true
      ) {
        next();
      }
    } else {
      next();
    }
  },
  methods: {
    ...mapActions("user", {
      updateUserAttribute: "updateUserAttribute",
      disconnectThirdParty: "disconnectThirdParty",
      loginThirdParty: "loginThirdParty",
      saveUserAttribute: "saveUserAttribute",
      getUserData: "getUserData"
    }),
    resetForm(scope) {
      Object.keys(this.fields[scope]).some(key => {
        (this.fields[scope][key].dirty = false),
          (this.fields[scope][key].touched = false);
      });
      setTimeout(() => {
        this.$validator.resume();
      }, 400);
    },
    update(e) {
      this.updateUserAttribute({
        attribute: e.target.name,
        value: e.target.value
      });
    },
    thirdPartyProviderToggle(provider, connected) {
      if (connected) {
        this.disconnectThirdParty(provider);
      } else {
        this.loading = provider;
        this.loginThirdParty(provider);
      }
    },
    savePassword() {
      this.$validator.validateAll("password").then(valid => {
        if (valid) {
          this.$validator.pause();

          this.saveUserAttribute({
            password: this.temp.password,
            password_confirmation: this.temp.password_confirmation,
            password_old: this.temp.password_old
          });

          this.temp.password_confirmation = "";
          this.temp.password_old = "";
          this.temp.password = "";
          this.resetForm("$password");
        }
      });
    },
    saveEmail() {
      this.$validator.validateAll("email").then(valid => {
        if (valid) {
          this.$validator.pause();
          this.saveUserAttribute({
            email: this.user.email,
            email_confirmation: this.temp.email_confirmation
          });
          this.temp.email_confirmation = "";
          this.resetForm("$email");
        }
      });
    },
    reload() {
      this.getUserData();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
